import axios from "axios";
import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
axios.interceptors.request.use(
  (config) => {
    const vuex = JSON.parse(localStorage.getItem("vuex"));
    if (vuex && vuex.token) {
      config.headers.Authorization = "Bearer " + vuex.token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: () => ({
    user: {
      email: null,
      password: null,
      name: null,
      surname: null,
      phone: null,
      province: null,
      city: null,
    },
    token: null,
    snackbar: {
      color: "red",
      msg: null,
      visible: false,
    },
    rates: null,
    subscriptions: [],
  }),
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setToken(state, token) {
      state.token = token;
    },
    setSnackbar(state, snackbar) {
      state.snackbar = snackbar;
    },
    setSubscriptions(state, subscriptions) {
      state.subscriptions = subscriptions;
    },
    setRates(state, rates) {
      state.rates = rates;
    },
    resetSubscription(state) {
      state.subscriptions = [];
    },
    resetSnackbar(state) {
      state.snackbar = {
        color: "red",
        msg: null,
        visible: false,
      };
    },
    logout(state) {
      state.user = {
        email: null,
        password: null,
        name: null,
        surname: null,
        phone: null,
        province: null,
        city: null,
      };
      state.token = null;
      state.snackbar = {
        color: "red",
        msg: null,
        visible: false,
      };
      state.subscriptions = [];
    },
  },
  actions: {
    userLogin({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post("/login", {
            email: payload.email,
            password: payload.password,
          })
          .then(async (response) => {
            commit("setUser", response.data.user);
            commit("setToken", response.data.token);
            resolve(response.data);
          })
          .catch((err) => {
            switch (err.response.data.errors.msg) {
              case "WRONG_PASSWORD":
                commit("setSnackbar", {
                  color: "red",
                  msg: "Email o password errate",
                  visible: true,
                });
                break;

              default:
                commit("setSnackbar", {
                  color: "red",
                  msg:
                    "Si è verificato un errore, ti preghiamo di riprovare, grazie",
                  visible: true,
                });
                break;
            }
            reject(err);
          });
      });
    },
    userRegister({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post("/patients", {
            email: payload.email,
            name: payload.name,
            surname: payload.surname,
            phone: payload.phone,
            province: payload.province,
            city: payload.city,
            role: "patient",
          })
          .then(() => {
            commit("setSnackbar", {
              color: "green",
              msg:
                "La password è stata inviata al tuo indirizzo email, accedi per procedere con l'acquisto",
              visible: true,
            });
            resolve(true);
          })
          .catch((err) => {
            commit("setSnackbar", {
              color: "red",
              msg:
                "Si è verificato un errore, ti preghiamo di riprovare, grazie",
              visible: true,
            });
            reject(err);
          });
      });
    },
    loadSubscriptions({ commit }, patientId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/subscriptions/${patientId}`)
          .then((response) => {
            commit("setSubscriptions", response.data.docs);
            resolve(response.data.docs);
          })
          .catch((err) => {
            commit("setSubscriptions", []);
            reject(err);
          });
      });
    },
    loadRates({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get("/rates")
          .then((response) => {
            commit("setRates", response.data.docs);
            resolve(response.data.docs);
          })
          .catch((err) => {
            commit("setRates", null);
            reject(err);
          });
      });
    },
  },
  getters: {
    getUser(state) {
      return state.user;
    },
    getToken(state) {
      return state.token;
    },
    getSnackbar(state) {
      return state.snackbar;
    },
    getRates(state) {
      return state.rates;
    },
    getSubscriptions(state) {
      return state.subscriptions;
    },
  },
});
